'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _latlng = require('./latlng');

var _latlng2 = _interopRequireDefault(_latlng);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react.PropTypes.arrayOf(_latlng2.default);


//////////////////
// WEBPACK FOOTER
// ./~/react-leaflet/lib/types/latlngList.js
// module id = 35
// module chunks = 0